import { Navigate, Route } from "react-router-dom";
import { pages } from "../../../utils/common";
import AcademicsLayout from "./academics.layout";
import AcademicView from "../academic/academic.view";
import ObepView from "../obep/obep.view";
import ObepDetailView from "../obep/obepDetail.view";
import AcademicsSubjectsView from "./academicsSubjects.view";
import AcademicsClassHubView from "./academicsClassHub.view";

const useAcademicsRoutes = () => (
  <Route path={pages.academics.path} element={<AcademicsLayout />}>
    <Route
      index
      element={<Navigate to={`${pages.academics.path}/obep`} replace />}
    />
    <Route path="obep/:id" element={<ObepDetailView />} />
    <Route path="obep" element={<ObepView />} />
    <Route path="courses" element={<AcademicView section="courses" />} />
    <Route path="subjects" element={<AcademicsSubjectsView />} />
    <Route
      path="classes/:classId/fee-structure"
      element={<AcademicsClassHubView />}
    />
    <Route
      path="classes/:classId/sections/:sectionId"
      element={<AcademicsClassHubView />}
    />
    <Route
      path="classes/:classId"
      element={<AcademicsClassHubView />}
    />
    <Route path="classes" element={<AcademicView section="classes" />} />
    <Route
      path="syllabus/assignment"
      element={<AcademicView section="syllabus-assignment" />}
    />
    <Route path="syllabus" element={<AcademicView section="syllabus" />} />
    <Route
      path="scoring-rubrics"
      element={<AcademicView section="scoring-rubrics" />}
    />
  </Route>
);

export default useAcademicsRoutes;
